// extracted by mini-css-extract-plugin
export var black = "TitleLink-module--black--121fb";
export var fadeInAnimation = "TitleLink-module--fadeInAnimation--7e13f";
export var link = "TitleLink-module--link--7c72e";
export var title = "TitleLink-module--title--f04a3";
export var white = "TitleLink-module--white--fbeb8";